import React from 'react';
import { Input } from '@perch-labs/shrike';
import { copyFor } from 'config';

const getCopy = copyFor('emailLogin.fields.email');

interface Props {
  margin?: Margin;
  onChange: (val: string) => void;
  value: string;
}

export const Email = ({ margin, onChange, value }: Props) => (
  <Input
    label={getCopy('label')}
    margin={margin}
    name="email"
    onChange={onChange}
    type="text"
    value={value}
    placeholder={getCopy('placeHolder')}
  />
);
